var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vpc-wrapper"},[_c('transition',{attrs:{"mode":"out-in","name":"vpc-layout"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1),_c('vpc-modal-common-error',{model:{value:(_vm.userCommonError),callback:function ($$v) {_vm.userCommonError=$$v},expression:"userCommonError"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }